import { render, staticRenderFns } from "./SettingsSecurityCourseIntro.vue?vue&type=template&id=a4eb3310&scoped=true"
import script from "./SettingsSecurityCourseIntro.vue?vue&type=script&lang=js"
export * from "./SettingsSecurityCourseIntro.vue?vue&type=script&lang=js"
import style0 from "./SettingsSecurityCourseIntro.vue?vue&type=style&index=0&id=a4eb3310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4eb3310",
  null
  
)

export default component.exports